export default __webpack_public_path__ + "static/media/treasure.84c4381d.png";